import script from "./ButtonReaction.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonReaction.vue?vue&type=script&setup=true&lang=js"

import "./ButtonReaction.vue?vue&type=style&index=0&id=4b28cf5a&lang=scss"

const __exports__ = script;

export default __exports__